import {
  Box,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  useTheme,
} from '@mui/material';

const MultiChipSelect = ({
  items = [],
  value = [],
  onChange,
  onClose,
  label = '선택',
  onClick,
  onFocus,
  disabled = false,
  labelYn = true,
  MenuProps,
  sx = {},
  labelSx = {},
}) => {
  const theme = useTheme();

  const getStyles = (name, selected, theme) => ({
    fontWeight:
      selected.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  });

  return (
    <FormControl fullWidth>
      {labelYn && <InputLabel id="multi-chip-label">{label}</InputLabel>}
      <Select
        labelId="multi-chip-label"
        multiple
        value={value}
        onChange={onChange}
        onClose={onClose}
        onClick={onClick}
        onFocus={onFocus}
        disabled={disabled}
        displayEmpty
        MenuProps={MenuProps}
        input={
          <OutlinedInput label="" notched={false} sx={{ pt: 1.0, pb: 1.0 }} />
        }
        sx={sx}
        renderValue={(selected) => {
          if (!selected || selected.length === 0) return null;
          return (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {selected.map((val) => {
                const item = items.find((i) => i.value === val || i.label === val);
                return <Chip key={val} size="small" label={item?.label ?? val} />;
              })}
            </Box>
          );
        }}
      >
        {items.map((item) => (
          <MenuItem
            key={item.value}
            value={item.value}
            style={getStyles(item.value, value, theme)}
          >
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default MultiChipSelect;
